/** Normalizes the common backend shape where a list endpoint can return either
 *  a bare array or a paginated `{ results: [] }` envelope. Use at the boundary
 *  of a React Query hook's `queryFn` to hand the caller a plain array. */
export function unwrapList<T>(data: T[] | { results?: T[] } | null | undefined): T[] {
  if (Array.isArray(data)) return data
  return data?.results ?? []
}
